<template>
  <!-- 舆情-新增-所涉州市 -->
  <div class="add_negative">
    <div class="steps">
      <div class="step actived">
        <span class="index">1</span>
        <span class="cont">舆情概况</span>
      </div>
      <div class="line"></div>
      <div class="step actived">
        <span class="index">2</span>
        <span class="cont">详细描述</span>
      </div>
      <div class="line"></div>
      <div class="step active">
        <span class="index">3</span>
        <span class="cont">所涉州市</span>
      </div>
    </div>
    <div class="content">
      <div class="accident">
        <div class="tip">所涉州市</div>
        <div class="drop_down" @click="showPop">
          <span v-if="selectCityNames.length==0">请选择</span>
          <span v-if="selectCityNames.length>0" class="selected">{{selectCityNames}}</span>
          <img src="@/assets/appraise/arrow_right.png" alt />
        </div>
      </div>
      <div v-if="cityList.length>1">
        <div class="accident" v-for="(city, index) in cityList" :key="index">
          <div class="tip">{{city.name}}扣分占比</div>
          <div class="input">
            <input type="text" v-model="city.deducRate" placeholder="请输入" />
            <span class="percent">%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bot_btns">
      <van-button @click="prevStep" class="prev_btn" type="primary">上一步</van-button>
      <van-button @click="save" class="next_btn" type="primary">保存</van-button>
    </div>
    <confirmDialog
      v-if="showDialog"
      :title="dialogTitle"
      :content="dialogContent"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></confirmDialog>
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
    <DropCheckbox
      ref="drop"
      :dataList="cityDataList"
      @confirm="selectCity"
      v-model="showCitySelect"
    ></DropCheckbox>
  </div>
</template>

<script>
import confirmDialog from "../components/confirmDialog.vue";
import DropCheckbox from "./components/DropCheckbox.vue";
import tipDialog from "./components/tipDialog";
import api from "@/service/modules/appraiseNew.js";
export default {
  components: {
    confirmDialog,
    DropCheckbox,
    tipDialog
  },
  data() {
    return {
      requireCont: "",
      showTips: false,
      showDialog: false,
      showCitySelect: false,
      cityList: [], // 选中的州市
      selectCityNames: "",
      dialogTitle: "",
      quarter: this.$route.query.quarter,
      year: this.$route.query.year,
      area: this.$route.query.area,
      dialogContent: "",
      cancelBtn: "",
      confirmBtn: "",
      show: false,
      message: "",
      overRate: false, // 扣分总占比是否为100%
      cityDataList: [],
      checkItems: []
    };
  },
  created() {
    this.queryCityList();
  },
  mounted() {},
  methods: {
    showPop() {
      if (this.$route.query.id && this.$route.query.id !== "undefined") return;
      this.showCitySelect = true;
    },
    // 获取已选城市数据
    queryCityDesc() {
      let negativeCitys = this.$store.state.appraise.negativeCitys;
      if (negativeCitys.cityList) {
        this.cityList = negativeCitys.cityList;
        // let list = [];
        // console.log(this.cityList,'cityList')
        // negativeCitys.cityList.forEach(item => {
        //   list.push({
        //     area: item.area,
        //     areaName: item.areaName,
        //     areaType: item.areaType,
        //     deducRate: '',
        //     id: null,
        //     name: item.areaName,
        //     sort: item.sort,
        //     sysCode: item.sysCode
        //   })
        // })
        // this.$refs.drop.checkItems = list;
        // console.log(this.$refs.drop.checkItems)
        this.cityList.forEach((item, index) => {
          if (index < this.cityList.length - 1) {
            this.selectCityNames += item.areaName + "、";
          } else {
            this.selectCityNames += item.areaName;
          }
        });
      } else {
        let obj = this.cityDataList.filter(item => {
          return item.area == this.$route.query.area;
        });
        this.cityList = obj;
        this.selectCityNames = obj[0].areaName;
        this.$refs.drop.checkItems = this.cityList;
      }
      // else {
      //     let obj = this.cityDataList.filter(item => {
      //       return item.area === this.$route.query.area
      //     })
      //     this.cityList.push(obj);
      //     this.selectCityNames = obj.areaName;
      //     this.$refs.drop.setCheckItems(this.cityList);
      //     this.$refs.drop.checkItems = this.cityList;
      // }
    },
    // 校验占比是否为正整数
    checkIsNumber() {
      let isNum = false;
      this.cityList.filter(item => {
        if (!/(^[1-9]\d*$)/.test(item.deducRate)) {
          isNum = true;
        }
      });
      return isNum;
    },
    // 校验总占比分数
    checkRate() {
      let allRate = 0;
      this.cityList.filter(item => {
        allRate += parseInt(item.deducRate);
      });
      if (allRate !== 100) {
        this.overRate = true;
      } else {
        this.overRate = false;
      }
      return this.overRate;
    },
    // 获取城市列表
    queryCityList() {
      let params = {};
      api.queryCityList(params).then(res => {
        if (res.ret === 0) {
          this.cityDataList = res.data.oneAreaTypeResVO.concat(
            res.data.twoAreaTypeResVO
          );
          this.queryCityDesc();
          this.cityDataList.forEach(item => {
            item.deducRate = "";
            item.name = item.areaName;
          });
        }
      });
    },
    // 上一步
    prevStep() {
      let data = {
        cityList: this.cityList
      };
      this.$store.commit("appraise/setNegativeCitys", data);
      // this.$router.back(-1);
      this.$router.replace(`/appraise/addNegativeDesc?id=${this.$route.query.id}&year=${this.year}&quarter=${this.quarter}&area=${this.area}`)
    },
    // checkList 选中本州市
    // initCityList(){
    //   let obj = this.cityDataList.filter(item => {
    //     return item.area === this.$route.query.area
    //   })
    //   this.cityList.push(obj);
    //   console.log()
    // },
    // 保存
    save() {
      if (this.cityList.length === 0) {
        this.showTips = true;
        this.requireCont = "请选择州市";
        return;
      }
      if (this.cityList.length > 1 && this.checkIsNumber()) {
        this.showTips = true;
        this.requireCont = "城市占比必须为正整数";
        return;
      }
      if (this.cityList.length > 1 && this.checkRate()) {
        this.showTips = true;
        this.requireCont = "扣分占比总和必须为100%";
        return;
      }
      (this.dialogTitle = "是否保存"),
        (this.cancelBtn = "放弃"),
        (this.confirmBtn = "保存"),
        (this.showDialog = true);
    },
    // 弹窗确认回调
    confirm() {
      let negativeSummary = this.$store.state.appraise.negativeSummary;
      let negativeDesc = this.$store.state.appraise.negativeDesc;
      let tableVOS = this.cityList;
      let files = negativeDesc.fileResVOS;
      tableVOS.forEach(item => {
        item.infoSource = negativeDesc.infoSource;
        item.infoUrl = negativeDesc.infoUrl;
        item.issuanceTime = negativeDesc.issuanceTime;
        item.netTend = negativeDesc.netTend;
        item.opinionDesc = negativeDesc.opinionDesc;
        item.opinionLevel = negativeSummary.opinionLevel;
        item.opinionTitle = negativeSummary.opinionTitle;
        item.opinionType = negativeSummary.opinionType;
        (item.quarter = this.quarter), (item.year = this.year);
      });
      let params = {
        files,
        tableVOS
      };
      api.badOpinionCreate(params).then(res => {
        if (res.ret === 0) {
          this.showDialog = false;
          // this.$router.replace(
          //   `/appraise/negativeList?area=${this.area}&year=${this.year}&quarter=${this.quarter}`
          // );
          this.$router.back(-2);
          // 清除vuex中的相关数据
          this.$store.commit("appraise/setNegativeSummary", {});
          this.$store.commit("appraise/setNegativeDesc", {});
          this.$store.commit("appraise/setNegativeCitys", {});
        }
      });
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
    // 选择
    selectCity(citys) {
      this.selectCityNames = "";
      this.cityList = citys;
      this.cityList.forEach((item, index) => {
        if (index < this.cityList.length - 1) {
          this.selectCityNames += item.name + "、";
        } else {
          this.selectCityNames += item.name;
        }
      });
      this.showCitySelect = false;
    }
  }
};
</script>

<style scoped lang="less">
.add_negative{
  width: 100%;
  height: 100%;
  position: relative;
}
.steps {
  padding: 25px 12px;
  background-color: #fbfbfb;
  & > div {
    display: inline-block;
  }
  .step.active {
    .cont {
      color: #36b374;
    }
    .index {
      background-color: #36b374;
    }
  }
  .step.actived {
    .cont {
      color: #36b374;
      opacity: 0.5;
    }
    .index {
      background-color: #36b374;
      opacity: 0.5;
    }
  }
  .index {
    display: inline-block;
    margin-right: 4px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    color: #fff;
    text-align: center;
    // background-color: #36B374;
    background-color: #ccc;
    border-radius: 50%;
    vertical-align: text-bottom;
  }
  .line {
    display: inline-block;
    margin: 0 11px;
    width: 38px;
    height: 1px;
    background-color: #ccc;
    vertical-align: middle;
  }
  .cont {
    font-size: 14px;
    color: #ccc;
  }
}
.content {
  padding: 0 12px 60px;
}
.accident {
  display: flex;
  justify-content: space-between;
  // padding: 16px 0;
  line-height: 46px;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input {
    // height: 43px;
    line-height: 43px;
  }
  .input input {
    width: 200px;
    font-size: 14px;
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    display: inline-block;
    
    span {
      display: inline-block;
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      margin-top: 17px;
      width: 12px;
      height: 12px;
      vertical-align: top;
    }
    span.selected {
      width: 240px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      text-align: right;
      color: #333;
      font-size: 14px;
    }
  }
}
.bot_btns {
  position: fixed;
  // position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 12px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  .van-button {
    width: 165px;
    height: 40px;
    background-color: #36b374;
  }
  .prev_btn {
    margin-left: 3px;
    margin-right: 15px;
    color: #36b374;
    background-color: #fff;
  }
}
@supports (bottom:  env(safe-area-inset-bottom)) {
  .add_negative{
    padding-bottom: calc( env(safe-area-inset-bottom));
  }
  .bot_btns{
    bottom:  env(safe-area-inset-bottom);
    bottom: constant(safe-area-inset-bottom);
  }
  .bot_btns::after{
    content: '';
    height:  env(safe-area-inset-bottom);
    height: constant(safe-area-inset-bottom);
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fff;
  }
}
span.tit {
  display: inline-block;
  width: 240px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  color: #333 !important;
  text-align: right;
}
.percent {
  width: 200px;
  font-size: 14px;
  color: #330000;
}
</style>